// removed by extract-text-webpack-plugin
module.exports = {"login-alert-wrapper":"PageLevelMessage__login-alert-wrapper","loginAlertWrapper":"PageLevelMessage__login-alert-wrapper","alert":"PageLevelMessage__alert"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/PageLevelMessage/PageLevelMessage.scss
// module id = 1670
// module chunks = 8